import { Input } from './input.component';
import type { InputProps } from './types';

export const EmailInput = (props: InputProps<'email'>) => <Input {...props} type='email' />;
